import z from "zod";
import { ORGANIZATION_AGENT_ICON_KEYS } from "./types/organization-agent.types.js";
export const ChatActionApprovalSchema = z.object({
    id: z.string(),
    title: z.string(),
    fields: z.array(z.object({
        label: z.string(),
        value: z.string(),
    })),
    status: z.enum([
        "PENDING",
        "APPROVED",
        "REJECTED",
        "EXECUTING",
        "SUCCEEDED",
        "FAILED",
    ]),
    source: z.enum(["manual", "explicit_request", "approve_for_me"]),
    error: z.string().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
const ChatMessageSourceFreshnessSchema = z.object({
    source: z.string(),
    updatedAt: z.string().nullable(),
    sourceType: z.string().optional(),
    url: z.string().optional(),
    freshnessLabel: z
        .enum(["fresh", "possibly_stale", "stale", "unknown"])
        .optional(),
});
const ChatMessageAgentSchema = z.object({
    id: z.string(),
    handle: z.string(),
    name: z.string(),
    iconKey: z.enum(ORGANIZATION_AGENT_ICON_KEYS),
});
const ChatCodeFileArtifactSchema = z.object({
    type: z.literal("code_file"),
    id: z.string(),
    title: z.string(),
    repoFullName: z.string(),
    ref: z.string(),
    htmlUrl: z.string().optional(),
    languageHint: z.string().optional(),
    content: z.string().nullable(),
    omitReason: z
        .enum(["binary", "too_large", "truncated", "unavailable"])
        .optional(),
    sizeBytes: z.number().optional(),
    lineCount: z.number().optional(),
});
const ChatTreeArtifactSchema = z.object({
    type: z.literal("tree"),
    id: z.string(),
    title: z.string(),
    repoFullName: z.string(),
    ref: z.string(),
    htmlUrl: z.string().optional(),
    truncated: z.boolean(),
    paths: z.array(z.string()),
});
const ChatDiffArtifactSchema = z.object({
    type: z.literal("diff"),
    id: z.string(),
    title: z.string(),
    repoFullName: z.string(),
    htmlUrl: z.string().optional(),
    truncated: z.boolean(),
    files: z.array(z.object({
        filename: z.string(),
        status: z.string(),
        patch: z.string().nullable(),
        omitReason: z.enum(["too_large", "binary", "unavailable"]).optional(),
    })),
});
const ChatMessageArtifactSchema = z.discriminatedUnion("type", [
    ChatCodeFileArtifactSchema,
    ChatTreeArtifactSchema,
    ChatDiffArtifactSchema,
]);
export const ChatMessageResponseSchema = z.object({
    id: z.string(),
    role: z.enum(["USER", "ASSISTANT", "SYSTEM"]),
    content: z.string(),
    createdAt: z.string(),
    sourceFreshness: z.array(ChatMessageSourceFreshnessSchema),
    agent: ChatMessageAgentSchema.nullable().optional(),
    artifacts: z.array(ChatMessageArtifactSchema),
    approvals: z.array(ChatActionApprovalSchema),
});
//# sourceMappingURL=chat.schema.js.map